import Http from '@/api/http.js'

export default {

  index() {
    return Http.get(`/addresses`)
  },

  indexByModel({model, id}) {
    return Http.get(`${model}/${id}/addresses`)
  },

  create(address){
    return Http.post(`/addresses`, {address: {...address}})
  },

  update(address){
    return Http.put(`/addresses/${address.id}`, {
      address: {...address},
    });
  },

  show(id) {
    return Http.get(`/addresses/${id}`);
  },


}
